<template>
  <div class="d-flex align-items-center" ref="dropdownWrapper">
    <div class="w-40">
      <label class="mb-0 fs-14 fw-500 font-mont color-344054">
        {{ label }}<span v-if="mandatory" class="color-red">*</span>
      </label>
    </div>
    <section class="w-60 multiselect">
      <div
        @click="toggleDropdown"
        :class="[
          {
            pointer: !disabled,
            'disabled-dropdown': disabled,
            'border-error': error,
          },
          'filter-inner-dropdown',
          'position-relative',
        ]"
      >
        <span
          class="text-capitalize"
          :class="
            value.length > 0
              ? 'font-mont fs-14 fw-500 color-black'
              : 'fw-400 fs-12 font-mont color-adaaaa'
          "
        >
          {{ selectedLabel }}
        </span>

        <img
          :class="{
            rotate180deg: opendropdown,
          }"
          src="../../assets/dashboard/small-down-arrow.svg"
          alt=""
        />
      </div>
      <div v-if="opendropdown" class="position-relative">
        <div
          class="filter-radio-dropdown filter-cand overflow-hidden p-0 multiselect-dd-values"
        >
          <b-form-group class="w-100">
            <div class="common-grey-input-field position-relative">
              <img
                class="common-searchbar"
                src="@/assets/dashboard/search-icon.svg"
                alt=""
              />
              <b-form-input
                placeholder="Search"
                debounce="300"
                type="search"
                style="border: 2px solid #ffffff; border-radius: 8px"
                class="search-input"
                v-model="searchQuery"
                :disabled="disabled"
              >
              </b-form-input>
            </div>
            <div class="overflow">
              <b-form-checkbox-group
                v-model="selected"
                class="singleselect filter-radio-dropdown-inner-content w-100 position-relative text-capitalize"
                size="sm"
                :options="filteredOptions"
                buttons
                stacked
                text-field="name"
                value-field="item"
              />

              <div
                v-if="filteredOptions.length === 0"
                class="no-result px-3 py-2 text-muted small text-center"
              >
                No results found
              </div>
            </div>
          </b-form-group>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    mandatory: Boolean,
    label: String,
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opendropdown: false,
      searchQuery: "",
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    selectedLabel() {
      const selectedItems = this.options.filter((opt) =>
        this.value.includes(opt.item)
      );
      return selectedItems.length
        ? `${selectedItems.length} Option${
            selectedItems.length > 1 ? "s" : ""
          } Selected`
        : "Select";
    },

    filteredOptions() {
      const search = this.searchQuery.trim().toLowerCase();
      if (!search) return this.options;
      return this.options.filter((opt) =>
        opt.name.toLowerCase().includes(search)
      );
    },
  },
  methods: {
    toggleDropdown() {
      if (!this.disabled) {
        this.opendropdown = !this.opendropdown;
      }
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdownWrapper;
      if (dropdown && !dropdown.contains(event.target)) {
        this.opendropdown = false;
      }
      this.searchQuery = "";
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style>
.multiselect .btn-group-toggle > .btn input[type="checkbox"],
.multiselect .btn-group-toggle > .btn-group > .btn input[type="checkbox"] {
  position: unset;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
  margin-right: 10px;
}
.multiselect-dd-values label {
  display: flex;
  align-items: center;
}
.disabled-dropdown {
  background: #f7f7f7;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border: unset;
}
</style>
